import type { ReactElement } from 'react';
import type { TabId } from '../types.js';

export interface SettingsDropdownProps {
  onNavigate: (id: TabId) => void;
}

export function SettingsDropdown({ onNavigate }: SettingsDropdownProps): ReactElement {
  function open(): void {
    onNavigate('settings');
  }

  return (
    <button
      type="button"
      aria-label="Settings"
      onClick={open}
      className="flex min-h-[48px] min-w-[48px] items-center justify-center rounded-md px-2"
      style={{ color: 'var(--text-main)' }}
    >
      <span aria-hidden="true">⚙️</span>
    </button>
  );
}